import React, { useEffect, useState } from "react";
import {
    Row,
    Col,
    Button,
    Input,
    Select,
    Space,
    InputNumber, DatePicker, Drawer, Form,
    Typography,
    message
} from "antd";
import { filterOption, formatInputNumber, formatNumber, parseInputNumber } from "../../../utils/funcHelper";
import { FORMAT_DATE, TYPE_COMMISSION, TYPE_MODAL, TYPE_TICKET } from "../../../constants/constants";

import { consoleLogUtil } from "../../../utils/consoleLogUtil";
import dayjs from "../../../utils/dayjsConfig";
import { CloseOutlined, PlusOutlined, SaveOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;
const { Option } = Select;
const EkipDetailDrawer = ({ isOpen, onSave, type, onClose, randomID, data, employees, positions, service_id }) => {
    const [form] = Form.useForm();
    const [isFormChanged, setIsFormChanged] = useState(false);
    const [commissionKTV, setCommissionKTV] = useState(0);
    consoleLogUtil("position ", positions);
    consoleLogUtil("data ", data);
    consoleLogUtil("service_id ", service_id);

    // Lấy tổng hoa hồng cấu hình cho vị trí KTV (position_id = 1) theo service_id
    const getTotalCommissionKTV = () => {
        const ktvPos =
            positions?.find(p => (p?.value ?? p?.id)?.toString() === '1');
        const rule = ktvPos?.rules?.find(r => r?.service_id === service_id);
        const raw = rule?.commission_value ?? 0;
        return typeof raw === 'string'
            ? Number(raw.replace(/,/g, '')) || 0
            : Number(raw) || 0;
    };

    const handleChangeEmployee = (rowIndex, value, option) => {
        consoleLogUtil("Selected employee:", option);
        const positionId =
            option?.position_id?.toString() ??
            null;
        if (positionId !== null && positionId !== undefined) {
            // Set value cho field ekips[rowIndex].position_id
            if (form.setFieldValue) {
                // antd v5
                form.setFieldValue(['ekips', rowIndex, 'position_id'], positionId);
            } else {
                // antd v4
                form.setFields([{ name: ['ekips', rowIndex, 'position_id'], value: positionId }]);
            }

            // Cập nhật income_amount_id dựa trên positionId
            const posOption = positions?.find(p => p?.value === positionId);
            consoleLogUtil("Found position option:", posOption);
            if (posOption) {
                form.setFieldValue(['ekips', rowIndex, 'income_amount'], posOption?.rules?.length > 0 ? (posOption?.rules?.find(r => r.service_id === service_id) ? posOption?.rules?.find(r => r.service_id === service_id).commission_value : 0) : 0);
            } else {
                form.setFieldValue(['ekips', rowIndex, 'income_amount'], 0);
            }
        }
    }

    const handleChangePosition = (rowIndex, value, options) => {
        consoleLogUtil("Selected position:", options);
        if (options?.rules?.length > 0) {
            form.setFieldValue(['ekips', rowIndex, 'income_amount'], options?.rules?.length > 0 ? (options?.rules?.find(r => r.service_id === service_id) ? options?.rules?.find(r => r.service_id === service_id).commission_value : 0) : 0);
        } else {
            form.setFieldValue(['ekips', rowIndex, 'income_amount'], 0);
        }
    }


    const onFinish = (values) => {
        consoleLogUtil("Final Form Values on Submit:", values);
        if (type === TYPE_MODAL.EDIT) {
            const ekips = values.ekips.map(e => ({
                ...e,
                type_income: TYPE_COMMISSION[1].value
            }));
            const updatedService = {
                ...data,
                ...values,
                ekips
            }
            consoleLogUtil("Updated Service on Edit:", updatedService);
            if (isFormChanged) {
                onSave(updatedService);
            } else {
                onClose();
            }
        } else {
            form.validateFields()
                .then((values) => {
                    const ekips = values.ekips.map(e => ({
                        ...e,
                        type_income: TYPE_COMMISSION[1].value,
                    }));
                    const updatedEkip = {
                        ...values,
                        ekips
                    }
                    onSave(updatedEkip);
                    onClose();
                })
        }
    }

    const handleDivideCommissionKTV = () => {
        const ekips = form.getFieldValue('ekips') || [];
        if (!ekips.length) return;

        // Lọc ra các dòng là KTV (position_id == 1)
        const ktvIndexes = ekips
            .map((e, idx) => ({ e, idx }))
            .filter(x => (x.e?.position_id ?? '').toString() === '1');

        const ktvCount = ktvIndexes.length;
        if (ktvCount === 0) {
            message.warning('Không có Kỹ thuật viên (position_id = 1) trong danh sách.');
            return;
        }

        const totalCommission = getTotalCommissionKTV();
        if (totalCommission <= 0) {
            message.warning('Không tìm thấy hoa hồng cho vị trí Kỹ thuật viên hoặc bằng 0.');
            return;
        }

        // Chia đều + dàn phần dư
        const base = Math.floor(totalCommission / ktvCount);
        let remainder = totalCommission - base * ktvCount;

        const updatedEkips = ekips.map((ekip, index) => {
            if ((ekip?.position_id ?? '').toString() === '1') {
                const extra = remainder > 0 ? 1 : 0; // dàn phần dư 1 VND cho các KTV đầu
                remainder = Math.max(0, remainder - extra);
                const amount = base + extra;
                return {
                    ...ekip,
                    // Đặt số (InputNumber sẽ tự format qua formatter)
                    income_amount: amount,
                };
            }
            return ekip;
        });

        form.setFieldsValue({ ekips: updatedEkips });
        setIsFormChanged(true);
    }

    useEffect(() => {
        if (type === TYPE_MODAL.ADD) {
            form.resetFields();
            form.setFieldsValue({
                session_date: dayjs(),
            });
        } else if (type === TYPE_MODAL.EDIT && data) {
            form.setFieldsValue({
                session_date: data.session_date ? dayjs(data.session_date) : null,
                ekips: data.ekips?.length > 0 ? data.ekips.map(e => ({
                    ...e,
                    employee_id: e?.employee_name ?? '',
                    position_id: e?.position_name ?? '',
                    income_amount: e?.income_amount ? formatNumber(parseInt(e?.income_amount)) : '',
                })) : [],
                notes: data.notes ?? '',
            });
        }
    }, [type, randomID]);
    return (
        <Drawer
            title={type === TYPE_MODAL.ADD ? "Thêm Ekip thực hiện" : "Thông tin Ekip thực hiện"}
            width={600}
            onClose={onClose}
            open={isOpen}
            styles={{
                body: {
                    paddingBottom: 80,
                },
            }}
            extra={null
            }
        >
            <Form
                layout="vertical"
                form={form}
                onFinish={onFinish}
                onValuesChange={() => setIsFormChanged(true)}
            >
                <Row gutter={16} align={"middle"}>

                    <Col span={12}>
                        <Form.Item
                            name="session_date"
                            label="Ngày thực hiện"
                            rules={[{ required: true, message: 'Vui lòng chọn ngày' }]}
                        >
                            <DatePicker
                                style={{ width: "100%" }}
                                format={FORMAT_DATE.DDMMYYYY}
                                disabled={type === TYPE_MODAL.EDIT}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Button
                            type="dashed"
                            danger
                            onClick={() => handleDivideCommissionKTV()}
                        >Chia đều tiền cho KTV</Button>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={24}>
                        <Form.List name="ekips">
                            {(fields, { add, remove }) => (
                                <>
                                    {fields.map(({ key, name, fieldKey, ...restField }) => (
                                        <Row gutter={16} key={key} align="middle">
                                            <Col span={1}>
                                                <Form.Item>
                                                    <Text>{name + 1}</Text>
                                                </Form.Item>
                                            </Col>
                                            <Col span={8}>
                                                <Form.Item
                                                    {...restField}
                                                    name={[name, 'employee_id']}
                                                    fieldKey={[fieldKey, 'employee_id']}
                                                    rules={[{ required: true, message: 'Vui lòng chọn nhân viên' }]}
                                                >
                                                    {
                                                        type === TYPE_MODAL.EDIT ?
                                                            <Input disabled style={{height: 32}} /> :
                                                            <Select
                                                                placeholder="Chọn nhân viên"
                                                                options={employees}
                                                                showSearch
                                                                filterOption={(input, option) =>
                                                                    option.label.toLowerCase().includes(input.toLowerCase())
                                                                }
                                                                onChange={(value, options) => handleChangeEmployee(name, value, options)}
                                                            />
                                                    }

                                                </Form.Item>
                                            </Col>
                                            <Col span={7}>
                                                <Form.Item
                                                    {...restField}
                                                    name={[name, 'position_id']}
                                                    fieldKey={[fieldKey, 'position_id']}
                                                    rules={[{ required: true, message: 'Vui lòng nhập vai trò' }]}
                                                >
                                                    {
                                                        type === TYPE_MODAL.EDIT ?
                                                            <Input disabled style={{height: 32}} /> :
                                                            <Select
                                                                placeholder="Chọn vai trò"
                                                                options={positions}
                                                                showSearch
                                                                filterOption={(input, option) =>
                                                                    option.label.toLowerCase().includes(input.toLowerCase())
                                                                }
                                                                onChange={(value, options) => handleChangePosition(name, value, options)}
                                                            />
                                                    }

                                                </Form.Item>
                                            </Col>
                                            <Col span={6}>
                                                <Form.Item
                                                    {...restField}
                                                    name={[name, 'income_amount']}
                                                    fieldKey={[fieldKey, 'income_amount']}
                                                    rules={[{ required: true, message: 'Nhập công tua' }]}
                                                >
                                                    <InputNumber 
                                                        disabled
                                                        className="input-number-cus-ant cus-input-number"
                                                        formatter={formatInputNumber}
                                                        parser={parseInputNumber}/>

                                                </Form.Item>
                                            </Col>
                                            <Col span={2}>
                                                <Form.Item>
                                                    {
                                                        type === TYPE_MODAL.EDIT ?
                                                            <span>{data?.type_income === TYPE_COMMISSION[0].value ? '%' : 'VNĐ'}</span> :
                                                            <Button
                                                                danger
                                                                icon={<CloseOutlined />}
                                                                onClick={() => remove(name)}
                                                                style={{ height: 30 }}
                                                            />
                                                    }

                                                </Form.Item>
                                            </Col>
                                        </Row>
                                    ))}
                                    <Form.Item>
                                        {
                                            type === TYPE_MODAL.EDIT ? null :
                                                <Button
                                                    type="dashed"
                                                    onClick={() => add()}
                                                    block
                                                    icon={<PlusOutlined />}
                                                >
                                                    Thêm nhân viên
                                                </Button>
                                        }

                                    </Form.Item>
                                </>
                            )}
                        </Form.List>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col span={24}>
                        <Form.Item
                            name="notes"
                            label="Ghi chú"
                        >
                            <Input.TextArea rows={4} placeholder="Nhập ghi chú" disabled={type === TYPE_MODAL.EDIT} />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={24} style={{ textAlign: "right" }}>
                        <Space>
                            <Button icon={<CloseOutlined />} onClick={onClose}>Đóng</Button>
                            {
                                type === TYPE_MODAL.EDIT ? null :
                                    <Button type="primary" htmlType="submit" icon={<SaveOutlined />}>
                                        Lưu
                                    </Button>
                            }

                        </Space>
                    </Col>
                </Row>
            </Form>
        </Drawer>
    )
}

export default EkipDetailDrawer;